export default __webpack_public_path__ + "static/media/games.685a3991.webp";